import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {[...Array(n)].map((_, i) => (
      <Star key={i} size={14} className="text-[#FFB100] fill-[#FFB100]" />
    ))}
  </div>
);

export default function ReviewTicker({ fallback = [] }) {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((r) => setReviews(r.data.reviews || []))
      .catch(() => setReviews([]));
  }, []);

  if (reviews === null) {
    return <div className="h-44" data-testid="review-ticker-loading" />;
  }

  if (reviews.length === 0) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {fallback.map((r, i) => (
          <figure key={i} data-testid={`review-card-${i}`} className="h-full glass-panel rounded-2xl p-8 flex flex-col">
            <Stars n={r.rating} />
            <blockquote className="mt-5 text-slate-300 leading-relaxed flex-1">“{r.quote}”</blockquote>
            <figcaption className="mt-6 pt-5 border-t border-white/10">
              <p className="font-display font-bold text-white text-sm">{r.author}</p>
              <p className="text-xs text-slate-500 mt-1">{r.role}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    );
  }

  const set = [...reviews, ...reviews, ...reviews];

  return (
    <div data-testid="review-ticker" className="marquee-hover relative overflow-hidden py-2 select-none">
      <div className="flex w-max animate-marquee gap-5 pr-5" style={{ animationDuration: "55s" }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex gap-5" aria-hidden={half === 1}>
            {set.map((r, i) => (
              <figure
                key={`${half}-${i}`}
                data-testid={half === 0 ? `review-ticker-card-${i}` : undefined}
                className="w-[320px] shrink-0 glass-panel rounded-2xl p-5 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <Stars n={r.rating} />
                  <span className="font-mono text-[10px] tracking-widest text-slate-500 uppercase">
                    App Store
                  </span>
                </div>
                <p className="mt-3 font-display font-bold text-white text-sm leading-snug">{r.title}</p>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed line-clamp-3">{r.text}</p>
              </figure>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}
